export const redirectToUrl = (url) => {
  if (!url || process.env.NODE_ENV === 'test') {
    return;
  }

  window.location.href = url;
};
